import React from 'react';
import Button from '../../../../../component/ui/Button';
import { hasPermission } from '../../../../../utils/controller';
import { useSelector } from 'react-redux';

export default function AccountDetailHeader({
	setIsOpenAccount,
	status,
	accountName,
	accountType,
	highlistText,
	setType,
	type,
	getList,
	setAccountId,
	setIsOpenActivateAccountModal,
	setIsOpenDeactivateAccountModal,
}) {
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	return (
		<div
			className="header-position-sticky p-4"
			style={{ backgroundColor: '#EDEDF7', borderBottom: '1px sold #0850ea' }}
		>

			<div className="d-flex align-items-center gap-2">
				<span className="fs-4 fw-light">Settings</span>
				<span className="fs-4 fw-light">{'>'}</span>
				<span className="fs-4 fw-light">Accounting</span>
				<span className="fs-4 fw-light">{'>'}</span>
				<span
					className="fs-4 fw-light text-primary cursor-pointer"
					onClick={() => {
						if (type === 'account-details') {
							setType('account-list');
						} else if (type === 'recent-transaction') {
							setType('account-details');
						}
					}}
				>
					Accounts
				</span>
				<span className="fs-4 fw-light">{'>'}</span>
				<span className="fs-4 fw-light">{accountName || ''}</span>
			</div>
			<div className='accounting-header-main'>
				<div>
					<div className="fs-3 fw-bold text-black">{accountName}</div>
					<div className="fs-3 fw-light text-black">{accountType}</div>
					<div
						className="fs-5 fw-light"
						style={{ color: '#718096' }}
					>
						{highlistText}
					</div>
				</div>

				{type === 'account-details' ? (
					<div className="d-flex gap-3 align-items-center">
						<Button
							type="button"
							button={'Edit'}
							dataTestId={'account-edit-button'}
							disabled={!hasPermission('settings.accounts.edit', user?.role?.role_permissions)}
							className="btn-primary mt-0 px-3"
							onClick={() => setIsOpenAccount(true)}
						/>
						<Button
							type="button"
							button={'Export'}
							dataTestId={'account-export-button'}
							disabled={!hasPermission('settings.accounts.export', user?.role?.role_permissions)}
							className="btn-gray mt-0 px-3"
							onClick={() => { }}
						/>
						<Button
							type="button"
							dataTestId={'account-status-button'}
							button={status === 1 ? 'Deactivate' : 'Activate'}
							disabled={!hasPermission('settings.accounts.edit', user?.role?.role_permissions)}
							className={`${status === 1 ? 'btn-danger' : 'btn-success'} mt-0 px-3`}
							onClick={() => {
								if (status === 0) {
									setIsOpenActivateAccountModal(true);
								} else if (status === 1) {
									setIsOpenDeactivateAccountModal(true);
								}
							}}
						/>
						<Button
							type="button"
							disabled={false}
							dataTestId={'account-close-button'}
							className="btn-danger mt-0"
							close
							onClick={() => {
								setType('account-list');
								setAccountId(null);
								getList();
							}}
						/>
					</div>
				) : (
					<Button
						type="button"
						disabled={false}
						dataTestId={'account-close-button'}
						className="btn-danger mt-0"
						close
						onClick={() => {
							setType('account-details');
						}}
					/>
				)}
			</div>
		</div>
	);
}
